import React from "react";
import Marquee from "react-fast-marquee";
import { useLang } from "@/contexts/LanguageContext";
import { Megaphone, Pin } from "lucide-react";

export default function AnnouncementsTicker({ items = [] }) {
  const { t, lang } = useLang();
  const fontH = lang === "ta" ? "font-serif-ta" : "font-serif-en";

  return (
    <section id="announcements" data-testid="announcements-section" className="bg-stone-100 border-y border-stone-200">
      <div className="max-w-7xl mx-auto px-6 md:px-10 py-3 flex items-center gap-4">
        <div className="shrink-0 flex items-center gap-2 text-emerald-900 font-medium pr-4 border-r border-stone-300">
          <Megaphone className="w-4 h-4" />
          <span className={`text-sm ${fontH}`}>{t("announcements_heading")}</span>
        </div>
        <div className="flex-1 overflow-hidden">
          {items.length === 0 ? (
            <div className="text-sm text-stone-500">{t("no_announcements")}</div>
          ) : (
            <Marquee gradient={false} speed={40} pauseOnHover>
              {items.map((a, i) => {
                const title = lang === "ta" && a.title_ta ? a.title_ta : a.title_en;
                const body = lang === "ta" && a.body_ta ? a.body_ta : a.body_en;
                return (
                  <span key={a.id} data-testid={`announcement-${i}`} className="inline-flex items-center gap-2 mx-8 text-sm text-stone-800">
                    {a.pinned && <Pin className="w-3.5 h-3.5 text-amber-700" />}
                    <span className="font-medium text-emerald-900">{title}</span>
                    {body && <span className="text-stone-600">— {body}</span>}
                  </span>
                );
              })}
            </Marquee>
          )}
        </div>
      </div>
    </section>
  );
}
